export default "__VITE_ASSET__BCB_KbZa__"